import React, { useState, useEffect } from "react";
import "./alert.css";
import {
  Drawer,
  Grid,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  TextField,
  InputAdornment,
  Typography,
  Menu,
  Alert,
  Skeleton,
} from "@mui/material";
import Swal from "sweetalert2";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CancelIcon from "@mui/icons-material/Cancel";
import StyledTableCell from "../../Tabletheme/Customtableheader";
import instance from "../../ApiInstance/Inetrceptor";
import AddIcon from "@mui/icons-material/Add";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "react-phone-number-input/style.css";
import CustomTheme from "../../Customtheme/Themes"

const Categories = () => {
  const { drawerWidth, isXs, isSm, isMd, isLg, isXl } = CustomTheme();
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [backDrop, setBackDrop] = useState(false);
  const [showmoreLoader, setShowmoreLoader] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [categoriesdata, setCategoriesdata] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [sortField, setSortField] = useState("alert_category_name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [totalRecods, setTotalRecods] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [category, setCategory] = useState("");
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [isAddSectionOpen, setIsAddSectionOpen] = useState(false);
  const [isEditSectionOpen, setIsEditSectionOpen] = useState(false);
  const [categoryadd, setCategoryadd] = useState({
    alert_category_id: 0,
    alert_category_name: "",
  });
  const open = Boolean(anchorEl);

  const handleinputChange = (event) => {
    const { id, value } = event.target;
    setCategoryadd((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  const handleinputEditChange = (event) => {
    const { id, value } = event.target;
    setCategory((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  const handleSort = (field) => {
    const order = field === sortField && sortOrder === "asc" ? "desc" : "asc";
    console.log("field", order);
    setSortField(field);
    setSortOrder(order);
    GetCategoryData(pageNo, field, order);
  };
  const GetCategoryData = (
    pageNumber = pageNo,
    field = sortField,
    order = sortOrder,
    searchText
  ) => {
    const body = {
      id: "",
      searchtext: searchText ?? "",
      pageno: pageNumber ?? 1,
      pagesize: 10,
      sortby: field ?? "",
      sortord: order ?? "",
    };
    instance
      .post("api/v1/Master/AlertCategory/Get", body)
      .then((res) => {
        const newData = res?.data?.Value ?? [];
        setTotalRecods(res?.data?.Records);
        if (pageNumber === 1) {
          setCategoriesdata(res?.data?.Value ?? []);
        } else {
          setCategoriesdata((prevData) => [...prevData, ...newData]);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  const handleButtonClick = () => {
    setIsDrawerOpen(true);
    setIsAddSectionOpen(true);
    setIsEditSectionOpen(false);
  };
  const handleEditClick = (event, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowIndex(index);
  };
  const handleDrawerClose = (event) => {
      setIsDrawerOpen(false);
  };
  const handleCloseErrorcode = () => {
    setError("");
  };
  const deletecategoryData = (entityId) => {
    instance
      .delete(`api/v1/Master/AlertCategory/Delete/${entityId}`)
      .then((res) => {
        const ResultData = res?.data?.ResultMessage ?? [];
        if (ResultData === "Deletion Success") {
          setCategoriesdata((prevData) => {
            return prevData.filter(row => row.alert_category_id !== entityId);
          });
           GetCategoryData();
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: ResultData,
            customClass: {
              confirmButton: "custom-confirm-button-class",
            },
            buttonsStyling: false,
            showCancelButton: false,
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: ResultData,
            customClass: {
              confirmButton: "custom-cancle-button-class",
            },
            buttonsStyling: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        console.log("newData12", err);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          customClass: {
            confirmButton: "custom-cancle-button-class",
          },
          buttonsStyling: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  const handleEdit = (event, caterory, index) => {
    if (event.target.innerText === "Edit") {
      setCategory(caterory);
      setIsDrawerOpen(true);
      setIsAddSectionOpen(false);
      setIsEditSectionOpen(true);
      setAnchorEl(null);
      setSelectedRowIndex(null);
    } else if (event.target.innerText === "Delete") {
      Swal.fire({
        icon: "question",
        text: "Are you sure you want to delete",

        customClass: {
          confirmButton: "custom-confirm-button-class",
          cancelButton: "custom-cancle-button-class",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        allowOutsideClick: false,
        reverseButtons: true, 
      }).then((responce) => {
        if (responce?.isConfirmed) {
          deletecategoryData(caterory?.alert_category_id);
        } else {
        }
      });
    }
    setAnchorEl(null);
    setSelectedRowIndex(null);
  };
  const handleAddNewClick = (event) => {
    event.stopPropagation();
    setIsDrawerOpen(true);
    const handlename = categoryadd?.alert_category_name?.trim();
    if (!handlename) {
      setError("Please enter Category Name.");
      setTimeout(() => {
        handleCloseErrorcode();
      }, 5000);
    } else {
      setBackDrop(true);
      const body = {
        alert_category_id: 0,
        alert_category_name: categoryadd.alert_category_name,
      };
      instance
        .post("api/v1/Master/AlertCategory/Post", body)
        .then((res) => {
          console.log("resp", res);
          if (res?.data?.Success) {
            setError("");
            setSuccess(res?.data?.ResultMessage);
            GetCategoryData(1);
            setTimeout(() => {
              setSuccess(null);
            }, 5000);
          } else {
            setError(res?.data?.ResultMessage);
            setTimeout(() => {
              setError(null);
            }, 5000);
          }
          setCategoryadd({
            alert_category_id: 0,
            alert_category_name: "",
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setBackDrop(false);
        });
    }
  };
  const handleEditNewClick = (event) => {
    event.stopPropagation();
    setIsDrawerOpen(true);
    const handlename = category?.alert_category_name?.trim();
    if (!handlename) {
      console.log("lkjlkkjh", category?.alert_category_name);
      setError("Please enter Category Name.");
      setTimeout(() => {
        handleCloseErrorcode();
      }, 5000);
    } else {
      setBackDrop(true);
      const body = {
        alert_category_id: category.alert_category_id,
        alert_category_name: category.alert_category_name,
      };
      instance
        .post("api/v1/Master/AlertCategory/Post", body)
        .then((res) => {
          console.log("resp", res);
          if (res?.data?.Success) {
            setError("");
            setSuccess(res?.data?.ResultMessage);
            GetCategoryData(1);
            setTimeout(() => {
              setSuccess(null);
            }, 5000);
          } else {
            setError(res?.data?.ResultMessage);
            setTimeout(() => {
              setError(null);
            }, 5000);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setBackDrop(false);
        });
    }
  };
  useEffect(() => {
    GetCategoryData(pageNo, sortField, sortOrder);
  }, [sortField, sortOrder]);

  return (
    <>
      <div className="parentAlert_div">
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="mb-4"
        >
          <p className="headingAlert_font">Alert Category</p>
          <p className="headAlert_div"></p>
        </div>
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item xl={1.9} lg={3.5} md={6} sm={12} xs={12}>
            <Button
              variant="contained"
              className="button_headerAlert"
              onClick={handleButtonClick}
              color="secondary"
              sx={{
                width: "100%",
              }}
            >
              Add Alert Category <AddIcon />
            </Button>
          </Grid>
          <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
            <div className="search-section d-flex">
              <div>
                <img src="assets/Images/searchicon.svg" alt="Search Icon" />
              </div>
              <div className="search-input">
                <input
                  onKeyUp={(event) => {
                    if (event.key === "Enter") {
                      GetCategoryData(
                        1,
                        sortField,
                        sortOrder,
                        event.target.value
                      );
                    }
                  }}
                  onChange={(event) => {
                    setSearchText(event.target.value);
                    if (event.target.value.length === 0) {
                      GetCategoryData(1, sortField, sortOrder, "");
                    }
                  }}
                  type="text"
                  placeholder="Search / Filter"
                />
              </div>
            </div>
          </Grid>
        </Grid>
        <Drawer
          anchor="right"
          open={isDrawerOpen}
          PaperProps={{
            sx: {
              width: drawerWidth, 
            },
          }}
        >
          <div
            style={{ padding: "20px" }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Button
                  id="back-button"
                  variant="contained"
                  color="transparent"
                  className="button_backAlert"
                  onClick={handleDrawerClose}
                  startIcon={<ArrowBackIcon onClose={handleDrawerClose}/>}
                >
                  Back
                </Button>
              </Grid>
              {/* ...//////.....Add New..///////////// */}
              {isAddSectionOpen && (
                <>
                  <Grid item xs={12}>
                    <Typography
                      variant="h5"
                      className="font-colorAlert mb-0"
                      style={{ fontWeight: "600" }}
                    >
                      Add Alert Category{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant="h7"
                      className="font-colorAlert mb-1"
                      style={{ fontWeight: "600" }}
                    >
                     Alert Category Information{" "}
                    </Typography>
                  </Grid>
                  {error && (
                    <Alert
                      variant="outlined"
                      severity="error"
                      icon={<CancelIcon onClick={handleCloseErrorcode} />}
                      className="errorAlert mt-4"
                    >
                      {error}
                    </Alert>
                  )}
                  {success && (
                    <Alert
                      variant="outlined"
                      severity="success"
                      className="sucessAlert mt-4"
                    >
                      {success}
                    </Alert>
                  )}
                  <Grid item xs={12}>
                    <InputLabel htmlFor="alert_category_name">
                      Category Name<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <TextField
                      id="alert_category_name"
                      size="small"
                      value={categoryadd?.alert_category_name}
                      onChange={(event) => handleinputChange(event)}
                      variant="outlined"
                      fullWidth
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{ textAlign: "right" }}
                    className="mt-4"
                  >
                    <Button
                      id="back-button"
                      variant="contained"
                      color="secondary"
                      onClick={(event) => handleAddNewClick(event)}
                    >
                    Save Changes
                    </Button>
                  </Grid>
                </>
              )}

              {/* ///////....Add Edit...///////////////// */}
              {isEditSectionOpen && (
                <>
                  <Grid item xs={12}>
                    <Typography
                      variant="h5"
                      className="font-colorAlert mb-0"
                      style={{ fontWeight: "600" }}
                    >
                      Edit Alert Category{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant="h7"
                      className="font-colorAlert mb-1"
                      style={{ fontWeight: "600" }}
                    >
                      Alert Category Information{" "}
                    </Typography>
                  </Grid>
                  {error && (
                    <Alert
                      variant="outlined"
                      severity="error"
                      icon={<CancelIcon onClick={handleCloseErrorcode} />}
                      className="errorAlert mt-4"
                    >
                      {error}
                    </Alert>
                  )}
                  {success && (
                    <Alert
                      variant="outlined"
                      severity="success"
                      className="sucessAlert mt-4"
                    >
                      {success}
                    </Alert>
                  )}
                  <Grid item xs={12}>
                    <InputLabel htmlFor="alert_category_name">
                      Category Name<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <TextField
                      id="alert_category_name"
                      size="small"
                      value={category.alert_category_name}
                      onChange={(event) => handleinputEditChange(event)}
                      variant="outlined"
                      fullWidth
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{ textAlign: "right" }}
                    className="mt-4"
                  >
                    <Button
                      id="back-button"
                      variant="contained"
                      color="secondary"
                      onClick={(event) => handleEditNewClick(event)}
                    >
                      Save Changes
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </div>
        </Drawer>

        <TableContainer sx={{ marginTop: 5, maxHeight: 600 }} component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow className="Table_rowAlert">
                <StyledTableCell
                  onClick={() => handleSort("alert_category_name")}
                >
                  Category Name
                  {sortField === "alert_category_name" && (
                    <>
                      {sortOrder === "asc" ? (
                        <img
                          src="assets/Images/Ascending.svg"
                          alt="Ascending"
                          style={{ width: "13px", marginLeft: "5px" }}
                        />
                      ) : (
                        <img
                          src="assets/Images/descending.svg"
                          alt="Descending"
                          style={{ width: "13px", marginLeft: "5px" }}
                        />
                      )}
                    </>
                  )}
                </StyledTableCell>
                <StyledTableCell />
              </TableRow>
            </TableHead>
            {loader ? (
              <>
                {new Array(3).fill(3).map((element, index) => {
                  return (
                    <TableRow key={index}>
                      {new Array(2).fill(1).map((element, index) => {
                        return (
                          <TableCell align="center" key={index}>
                            <Skeleton
                              variant="rounded"
                              width={"100%"}
                              height={60}
                            />
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </>
            ) : (
              <>
                {categoriesdata.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      <p>No Data Found</p>
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableBody>
                    {categoriesdata.map((caterory, index) => (
                      <TableRow key={index}>
                        {/* key={caterory.id}> */}
                        <TableCell>{caterory.alert_category_name}</TableCell>
                        <TableCell>
                          <div style={{ textAlign: "center" }}>
                            <MoreVertIcon
                              onClick={(event) => handleEditClick(event, index)}
                              id="basic-button"
                              aria-controls={
                                Boolean(anchorEl)
                                  ? `basic-menu-${index}`
                                  : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={
                                Boolean(anchorEl) ? "true" : undefined
                              }
                            />
                            <Menu
                              id={`basic-menu-${index}`}
                              anchorEl={anchorEl}
                              open={
                                selectedRowIndex !== null &&
                                selectedRowIndex === index
                              }
                              onClose={handleEdit}
                              MenuListProps={{
                                "aria-labelledby": `basic-button-${index}`,
                              }}
                            >
                              <MenuItem
                                onClick={(event) => {
                                  handleEdit(event, caterory, index);
                                }}
                              >
                                Edit
                              </MenuItem>
                              <MenuItem
                                onClick={(event) => {
                                  handleEdit(event, caterory, index);
                                }}
                              >
                                Delete
                              </MenuItem>
                            </Menu>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
        <Grid item xs={12} className="mt-4" sx={{ textAlign: "center" }}>
          {totalRecods > categoriesdata.length && categoriesdata.length > 0 && (
            <Button
              id="back-button"
              variant="contained"
              color="secondary"
              sx={{ textTransform: "none" }}
              onClick={() => {
                setShowmoreLoader(true);
                setPageNo((prev) => prev + 1);
                GetCategoryData(pageNo + 1,sortField, sortOrder);
              }}
            >
              {showmoreLoader ? "loading" : "Show More"}
            </Button>
          )}
        </Grid>
      </div>
    </>
  );
};

export default Categories;
